export default "__VITE_ASSET__BDX94OXq__"